import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { userAppContext } from '../context/Context';
import { FeatureTrialSuccess } from '../modules/featureBilling';
import PaymentSuccessService from '../services/PaymentSuccessService';
import SharedButton from '@/global/Button/Button';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(true);
  const { setUser, setGroups } = userAppContext();
  const isGseaFeature = searchParams.get('feature') === 'gsea';

  useEffect(() => {
    const session_id = searchParams.get('session_id');

    if (session_id && !isGseaFeature) {
      PaymentSuccessService.refreshUserSession(setUser, setGroups).finally(() => {
        setIsRefreshing(false);
      });
      return;
    }

    setIsRefreshing(false);
  }, [searchParams, setUser, setGroups, isGseaFeature]);

  const handleContinue = () => {
    navigate('/Profile-area');
  };

  if (isGseaFeature) {
    return (
      <FeatureTrialSuccess
        onStartAnalysis={() => navigate('/gsea-ranked')}
        onManageSubscription={() => navigate('/Profile-area#subscriptions')}
      />
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Payment Successful - DISGENET</title>
        <meta name="description" content="Your payment has been processed successfully." />
      </Helmet>

      <div
        className="flex w-full items-center justify-center px-4 py-8 text-center"
        style={{ height: 'calc(100dvh - var(--layout-header-offset,68px))' }}
      >
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8">
          <div className="mb-6">
            <i className="bi bi-check-circle-fill text-pink text-6xl"></i>
          </div>

          <h1 className="text-2xl font-bold text-gray-800 mb-4">Payment Successful!</h1>

          <p className="text-gray-600 mb-6">
            Thank you for your purchase. Your payment has been processed successfully.
            {isRefreshing && " We're updating your account..."}
          </p>

          {isRefreshing && (
            <div className="mb-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
              <p className="text-sm text-gray-500 mt-2">Updating your account...</p>
            </div>
          )}

          {!isRefreshing && (
            <div className="mb-4 flex items-center gap-2 justify-center flex-col bg-blue px-4 py-2 rounded-lg shadow-md">
              <p className="text-sm text-white mb-0 font-semibold">Your account has been updated!</p>
            </div>
          )}

          <div className="space-y-4">
            <SharedButton onClick={handleContinue} disabled={isRefreshing}>
              {isRefreshing ? 'Please wait...' : 'Go to Profile'}
            </SharedButton>

            <p className="text-sm text-gray-500">You will receive a confirmation email shortly.</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PaymentSuccess;
